<template>
	<div class="OrganisationFilter">
		<Multiselect
			v-bind="multiselectProps"
			@updateValues="handleMultiselectUpdate"
			@searchChange="handleSearchChange"
		/>
		<div v-if="selectedItems.length > 0" class="List">
			<CheckBoxSelectItem
				v-for="item in selectedItems"
				:key="item.value"
				:item="item"
				@selectionChange="(state) => handleSelectionChange(item, state)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import Multiselect from '@components/Multiselect/Multiselect.vue';
import CheckBoxSelectItem from '@components/CheckBoxSelectItem/CheckBoxSelectItem.vue';
import { MultiselectMode } from '@app/enums/MultiselectMode';
import { useOrganisationFilter } from '@composables/useOrganisationFilter';
import { computed } from 'vue';

const {
	placeholder,
	multiselectValue,
	multiselectOptions,
	isLoading,
	selectedItems,
	footer,
	handleSelectionChange,
	handleMultiselectUpdate,
	handleSearchChange
} = useOrganisationFilter();

const multiselectProps = computed(() => ({
	options: multiselectOptions.value,
	modelValue: multiselectValue.value,
	mode: MultiselectMode.TAGS,
	placeholder,
	loading: isLoading.value,
	footer: footer.value
}));
</script>

<style scoped lang="scss">
.OrganisationFilter {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1rem;
	@include AddBorderBeforeElement(1, 2);	// required for outline not to be cut off

	.List {
		display: flex;
		flex-direction: column;
		overflow: auto;
		scrollbar-width: none;
		padding: 2px 2px 0 0;	// required for outline not to be cut off

		&::-webkit-scrollbar {
			display: none;
		}
	}
}
</style>
